import React from 'react';

import { useHistory } from 'react-router-dom';
import { useUserWithRole } from 'hooks/custom-auth';
import { getRoutePrefix } from 'utils/routes';
import Client from 'containers/app/client';
import { LayoutPage, LayoutHorizontal } from 'components/layouts';
import LoadingFullPage from 'components/loading-full-page';
import { Button } from 'antd';
import './style.css';

const ProfileComplete = () => {
  const history = useHistory();
  const [user, loading] = useUserWithRole(Client.auth);

  if (loading) return <LoadingFullPage />;

  const contentWorker = (
    <>
      <h1>Fantastic!</h1>
      <br />
      <p>
        Thank you for signing up with MyShifts. You can now relax and keep an
        eye on your phone for MyShifts alerts, which will notify you when you have
        been matched for a MyShifts work opportunity.
        <br />
        <strong>
          Remember the quicker you respond the quicker you can get shifts booked
          in!
        </strong>
      </p>
      <h3>Welcome to the MyShifts Team.</h3>
      <br />
    </>
  );

  const contentEmployer = (
    <>
      <h1>Fantastic!</h1>
      <br />
      <p>
        Thank you for taking the time to complete the sign-up sections. Now sit
        back and relax for a while and wait for us to send you an email with
        confirmation of your sign up.
      </p>
      <p>
        Thank you for signing up with MyShifts. You can now start searching for
        your worker heroes by logging in and posting vacant shifts. MyShifts
        will post any shift requests promptly and you will receive{' '}
        <strong>matched worker</strong> mini profiles almost instantly.
      </p>
      <h3>Welcome to the MyShifts service.</h3>
      <br />
    </>
  );

  const content =
    user.claims.role === 'isWorker' ? contentWorker : contentEmployer;

  const onSubmit = async () => {
    history.push(`${getRoutePrefix(user.claims.role)}/dashboard`);
  };

  return (
    <LayoutPage className="profile-complete">
      <LayoutHorizontal className="profile-complete-container">
        <div className="content">
          {content}
          <Button type="primary" size="large" onClick={onSubmit}>
            Continue
          </Button>
        </div>
      </LayoutHorizontal>
    </LayoutPage>
  );
};

export default ProfileComplete;
